// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocalContactInfo_wrapper__2fqCp","actions":"LocalContactInfo_actions__3qo-A","btn":"LocalContactInfo_btn__3RVwf"};